module.exports = __webpack_public_path__ + "static/media/2020-06-05 pair-programming.d64e3e30.md";